import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/sections/home/home.component';


import { LayoutErrorNotFoundComponent } from '@core/components/layout/errors/not-found/not-found.component';
import { ErrorsFullScreenComponent } from '@core/components/layout/errors/errors-full-screen/errors-full-screen.component';

import { AppSettingsRouterModule } from './routes/settings-router.module';
import { AppProjectsRouterModule } from './routes/projects-router.module';
import { AppLibraryRouterModule } from './routes/library-router.module';
import { AppVersionsRouterModule } from './routes/versions-router.module';
import { AppDashboardRouterModule } from './routes/dashboard-router.module';
import { AppApprovalsRouterModule } from './routes/approvals-router.module';
import { AppAIRouterModule } from './routes/ai-router.module';
import { AppBridgesRouterModule } from './routes/bridges-router.module';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'error/:key',
        component: ErrorsFullScreenComponent
    },
    {
        path: 'p',
        //component: PluginComponent,
        //children: pluginRoutes,
        // canActivate: [ AccessPluginsService ]
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '**',
        component: LayoutErrorNotFoundComponent
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
        AppSettingsRouterModule,
        AppProjectsRouterModule,
        AppLibraryRouterModule,
        AppVersionsRouterModule,
        AppDashboardRouterModule,
        AppApprovalsRouterModule,
        AppAIRouterModule,
        AppBridgesRouterModule

    ],
    exports: [RouterModule]
})
export class AppRouterModule { }
